import React from 'react';
import ChatList from 'modules/chat/chatList';
import useGetChatted from './hooks/useGetChatted';
import useDeleteChat from './hooks/useDeleteChat';
import DotsLoading from 'components/loadings/dotsLoading';
import Header from 'modules/header/wholesaler/home';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';
const ChatContainer = () => {
  const {userChatData, userChatDataIsloading, refetch} = useGetChatted({
    app: 'MARKET',
  });

  const {mutate} = useDeleteChat({refetch});
  return (
    <div className="flex flex-col w-full h-full gap-4">
      <Header />
      <div className="flex flex-col">
        {userChatDataIsloading ? (
          <DotsLoading />
        ) : userChatData?.results.length === 0 ? (
          <div className=" mt-28">
            <img src={EmptyPost} alt="empty" className=" block mx-auto" />
            <p className=" text-gray-5 text-center">
              موردی برای نمایش وجود ندارد.
            </p>
          </div>
        ) : (
          <ChatList
            chats={userChatData?.results}
            optionsChatItem={[
              {
                icon: <div className="icon-trash text-[18px]" />,
                action: id => mutate(id),
                title: 'حذف',
              },
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default ChatContainer;
